export const handleMensurationEffluentTreatment = (prev, values, currentStep, callback) => {
	switch(currentStep){
		case "1"		: return validateStep1(prev, values, callback);		// 1.3.1
		case "2"		: return validateStep2(prev, values, callback);		// 1.3.2 
		case "2-1"	: return validateStep21(prev, values, callback);	// 1.4.2.2 !=b
		case "2-2"	: return validateStep22(prev, values, callback);	// 1.3.2.3 !=b
		case "2-3"	: return validateStep23(prev, values, callback);	// 1.3.2.1 ==d
		case "2-4"	: return validateStep24(prev, values, callback);	// 1.4.4 ==a
		case "2-5"	: return validateStep25(prev, values, callback);	// 1.4.4.1 ==a
		default 		: return "1" ;
	}
};

function validateStep1(prev, values, callback) {
	if(prev) return "return";

	callback(mapToApi(values), "mensuration");
	return "2";
};

function validateStep2(prev, values, callback) {
	if(prev) return "1";

	callback(mapToApi(values), "mensuration");
	return values && values["2"] == "B" ? "end" : "2-1";
};

function validateStep21(prev, values, callback) {
	if(prev) return "2";

	callback(mapToApi(values), "mensuration");
	return "2-2";
};

function validateStep22(prev, values, callback) {
	if(prev) return "2-1";

	callback(mapToApi(values), "mensuration");
	if(values && values["2"] == "D") return "2-3";
	if(values && values["2"] == "A") return "2-4";
	else return "end";
};

function validateStep23(prev, values, callback) {
	if(prev) return "2-2";

	callback(mapToApi(values), "mensuration");
	if (values && values["2"] == "D") return "2-4";
	return "end";
};

function validateStep24(prev, values, callback) {
	if(prev) return "2-2";

	callback(mapToApi(values), "mensuration");
	if (values && values["2-4"] != "yes") return "end";
	return "2-5";
};

function validateStep25(prev, values, callback) {
	if(prev) return "2-4";
	callback(mapToApi(values), "mensuration");
	return "end";
};

function mapToApi(values) {
	return {
		effluentTreatment: {
			"1": {
				jan: values["1"] ? parseInt(values["1"].effluentVolume.jan) : 0,
				feb: values["1"] ? parseInt(values["1"].effluentVolume.feb) : 0,
				mar: values["1"] ? parseInt(values["1"].effluentVolume.mar) : 0,
				apr: values["1"] ? parseInt(values["1"].effluentVolume.apr) : 0,
				may: values["1"] ? parseInt(values["1"].effluentVolume.may) : 0,
				jun: values["1"] ? parseInt(values["1"].effluentVolume.jun) : 0,
				jul: values["1"] ? parseInt(values["1"].effluentVolume.jul) : 0,
				aug: values["1"] ? parseInt(values["1"].effluentVolume.aug) : 0,
				sep: values["1"] ? parseInt(values["1"].effluentVolume.sep) : 0,
				oct: values["1"] ? parseInt(values["1"].effluentVolume.oct) : 0,
				nov: values["1"] ? parseInt(values["1"].effluentVolume.nov) : 0,
				dec: values["1"] ? parseInt(values["1"].effluentVolume.dec) : 0,
			},
			"2"		: values["2"],
			"2-1"	: values["2-1"] ? [...values["2-1"]] : [],
			"2-2"	: values["2-2"] ? values["2-2"].description : "",
			"2-3"	: values["2-3"] ? parseInt(values["2-3"].efluentGerated) : 0,
			"2-4"	: values["2-4"] == "yes" ? true : false,
			"2-5"	: {
				"DBO": values["2-5"] && values["2-5"].DBO ? values["2-5"].DBO : "",
				"NAT": values["2-5"] && values["2-5"].NAT ? values["2-5"].NAT : "",
			}
		}
	};
}


// WEBPACK FOOTER //
// src/helpers/subcategoriesFunctions/handleMensurationEffluentTreatment.js